import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';
import {
  Environment,
  NimmstaCommonsModuleConfiguration,
} from '../nimmsta-commons-module.config';

@Injectable()
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  private env = inject(NimmstaCommonsModuleConfiguration).environment;

  handle(params: MissingTranslationHandlerParams): string {
    const { key, translateService } = params;
    const fallbackMessage = (
      params.interpolateParams as Record<string, unknown> | undefined
    )?.['fallbackMessage'];
    if (typeof fallbackMessage === 'string' && fallbackMessage.trim()) {
      return fallbackMessage;
    }

    // In development, log the missing translation for debugging
    if (this.env !== Environment.PROD) {
      console.error(
        `Missing translation for key: "${key}" in language: "${translateService.getCurrentLang()}"`,
      );
    }

    // Return a formatted version of the key
    return this.formatMissingKey(key);
  }

  private formatMissingKey(key: string): string {
    if (!key) {
      return '[MISSING_KEY]';
    }

    // Convert dot notation to a more readable format
    // e.g., "common.button s.save" becomes "Save"
    const parts = key.split('.');
    const lastPart = parts[parts.length - 1];

    // Convert camelCase and snake_case to readable text
    const formatted = lastPart
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
      .replace(/\b\w/g, (l) => l.toUpperCase()) // Capitalize first letter of each word
      .trim();

    switch (this.env) {
      case Environment.LOCAL:
      case Environment.DEV:
      case Environment.STAGING:
        return `[MISSING: ${key}]`;
      case Environment.PROD:
      default:
        return formatted;
    }
  }
}
